import type { GenderFilter } from '../../lib/scoreboard-view';

const chipClass = (selected: boolean) =>
  `inline-flex min-h-11 items-center gap-1.5 rounded-full px-4 text-sm font-medium ${
    selected
      ? 'bg-[var(--color-accent-subtle)] text-[var(--color-accent-hover)]'
      : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-surface-2)]'
  }`;

const OPTIONS: { value: GenderFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

/** Admin scoring: All / Male / Female. Sits next to the age-group chips and uses the same `gender` query. */
export function GenderRosterFilter({
  value,
  counts,
  onChange,
}: {
  value: GenderFilter;
  counts: Record<GenderFilter, number>;
  onChange: (value: GenderFilter) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium text-[var(--color-text-secondary)]">Gender</span>
      <div className="flex flex-wrap gap-1" role="group" aria-label="Gender">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            aria-pressed={value === option.value}
            onClick={() => onChange(option.value)}
            className={chipClass(value === option.value)}
          >
            {option.label}
            <span className="tabular-nums opacity-70">{counts[option.value]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
